// src/contexts/AuthContext.js

import React, { createContext, useContext, useEffect, useState } from 'react'
import { auth, db } from '../firebase'
import {
  signInWithEmailAndPassword,
  sendPasswordResetEmail,
  signOut,
  onAuthStateChanged,
} from 'firebase/auth'
import {
  doc,
  onSnapshot,
} from 'firebase/firestore'

const AuthContext = createContext()

export function useAuth() {
  return useContext(AuthContext)
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null)
  const [userRole, setUserRole] = useState(null)
  const [loading, setLoading] = useState(true)
  const [authed, setAuthed] = useState(false)
  const [userStatus, setUserStatus] = useState(null)

  // 1) Email/Password ile Giriş (Login)
  function login(email, password) {
    return signInWithEmailAndPassword(auth, email, password)
  }

  // 3) Şifre sıfırlama
  function resetPassword(email) {
    return sendPasswordResetEmail(auth, email)
  }

  // 4) Çıkış yapma
  function logout() {
    return signOut(auth)
  }

  // 5) Mevcut kullanıcıyı izleme (onAuthStateChanged)
  useEffect(() => {
    const unsubscribeAuth = onAuthStateChanged(auth, async (user) => {
      if (user) {
        if (user.isAnonymous) {
          setCurrentUser({
            uid: user.uid,
            email: '',
            avatarUrl: '',
            nickname: '',
            isAnonymous: true,
          })
          setUserRole('guest')
          setUserStatus('active')
          setAuthed(true)
          setLoading(false)
          return
        }

        // Ardından Firestore'daki kullanıcının verilerini dinle
        const userDocRef = doc(db, 'users', user.uid)
        const unsubscribeUserDoc = onSnapshot(userDocRef, async (snapshot) => {
          if (snapshot.exists()) {

            const userData = snapshot.data()
            setCurrentUser({
              uid: user.uid,
              email: user.email,
              avatarUrl: userData.avatarUrl || '',
              nickname: userData.nickname || '',
              reportSurveyCodes: Array.isArray(userData.reportSurveyCodes)
                ? userData.reportSurveyCodes
                : [],
              isAnonymous: false,
            })
            setUserRole(userData.role || 'user')
            setUserStatus(userData.status || 'active')
          } else {
            // Yalnızca admin tarafından users kaydı oluşturulmuş hesaplar girebilir.
            await signOut(auth)
            setCurrentUser(null)
            setUserRole(null)
            setUserStatus(null)
            setAuthed(false)
            setLoading(false)
            return
          }
          setAuthed(true)
          setLoading(false)
        })

        return () => {
          unsubscribeUserDoc()
        }
      } else {
        // Kullanıcı yoksa state sıfırla
        setCurrentUser(null)
        setUserRole(null)
        setUserStatus(null)
        setAuthed(false)
        setLoading(false)
      }
    })

    // Cleanup
    return () => {
      unsubscribeAuth()
    }
  }, [])

  // Context olarak döndüreceğimiz değerler
  const value = {
    currentUser,
    userRole,
    authed,
    userStatus,
    setAuthed,
    login,
    resetPassword,
    logout,
  }

  return (
    <AuthContext.Provider value={value}>
      {/* loading false olana kadar children'ı göstermeyelim */}
      {!loading && children}
    </AuthContext.Provider>
  )
}
